import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/consumo';
import Consumo from './ConsumoList';

const ms2p = (state) => {
  return {
    ...state.consumo_prd,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Consumo);
